<template>
  <div class="flex flex-col gap-3 w-full">
    <boost-item :key="index" @itemClick="" title="Privacy Policy" icon="fa-solid fa-shield-halved">
      <p class="text-GREY text-xs">Your data, your treasure—protected with care.</p>
      <template #suffix>
        <font-awesome-icon class="arrow_icon_color" icon="fa-solid fa-angle-right" /> </template
    ></boost-item>
    <boost-item :key="index" @itemClick="" title="Term of Use" icon="fa-solid fa-file-lines">
      <p class="text-GREY text-xs">Sail by the rules, avoid walking the plank!</p>

      <template #suffix>
        <font-awesome-icon class="arrow_icon_color" icon="fa-solid fa-angle-right" /> </template
    ></boost-item>
    <boost-item
      :key="index"
      @itemClick="openLanguageDrawer()"
      title="Language"
      icon="fa-solid fa-globe"
    >
      <p class="text-GREY text-xs">Set the tongue ye speak—pirate lingo optional.</p>
      <template #suffix>
        <font-awesome-icon class="arrow_icon_color" icon="fa-solid fa-angle-right" /></template
    ></boost-item>
    <boost-item
      :key="index"
      @itemClick="openDeleteAccountDrawer()"
      title="Delete Account"
      icon="fa-solid fa-user-xmark"
      delete
    >
      <p class="text-GREY text-xs">Parting ways? We'll miss ye on the high seas.</p>

      <template #suffix>
        <font-awesome-icon class="arrow_icon_color" icon="fa-solid fa-angle-right" /> </template
    ></boost-item>
  </div>
</template>
<script setup>
import { openBottomDrawer, sizeClass } from '@/composables/bottomdrawer'
import BoostItem from '../BoostItem.vue'
import LanguageDrawer from '../drawers/LanguageDrawer.vue'
import DeleteAccountDrawer from '../drawers/DeleteAccountDrawer.vue'

const openLanguageDrawer = () => {
  openBottomDrawer(LanguageDrawer, {
    props: {},
    backgroundColor: 'bg-white',
    xmarkColor: 'arrow_icon_color',
    emits: {},
    size: 'md'
  })
}

const openDeleteAccountDrawer = () => {
  openBottomDrawer(DeleteAccountDrawer, {
    props: {},
    backgroundColor: 'bg-white',
    xmarkColor: 'arrow_icon_color',
    emits: {},
    size: 'sm'
  })
}
</script>
